module.exports = __webpack_public_path__ + "static/media/login-img.7f1d6bf5.png";